import { Injectable } from '@angular/core';
import {Restangular} from 'ngx-restangular';

@Injectable({
  providedIn: 'root'
})
export class RebatesService {

  private cachedCategories;
  private cachedOffers = [];
  private GROUPON_COMMISSION_RATIO = 0.1;
  private USER_CASHBACK_RATIO = 0.5;

  private GROUPON = true;

  constructor(
      private restangular: Restangular
  ) {

  }

  getCategory(slug): Promise<any> {
    return this.getCategories().then(result => {
      return result.find(category => category.slug === slug);
    });
  }

  getCategories(): Promise<any> {
    if (this.cachedCategories) {
      return Promise.resolve(this.cachedCategories);
    }
    return this.restangular.one('v3').one('rebates').all('categories').getList().toPromise().then(results => {
      const categories = results.map(category => category.category);
      this.cachedCategories = categories;
      return categories;
    });
  }

  private reformatResults(results) {
    if (this.GROUPON) {
      const offers = results.map((deal, index) => {
        if ('preferredOfferIndex' in deal) {
          const preferredOption = deal.options[deal.preferredOfferIndex];
          return {
            type: 'groupon',
            id: preferredOption.id,
            _raw: deal,
            title: deal.title,
            short_title: deal.title,
            discount_percentage: preferredOption.discountPercent / 100,
            cashback_percentage: this.GROUPON_COMMISSION_RATIO * this.USER_CASHBACK_RATIO,
            price: preferredOption.price.amount / 100,
            url: preferredOption.buyUrl,
            image_url: deal.largeImageUrl,
            merchant: {
              name: deal.merchant.name,
              latitude: preferredOption.redemptionLocationCount > deal.preferredLocationIndex ? preferredOption.redemptionLocations[deal.preferredLocationIndex].lat : deal.division.lat,
              longitude: preferredOption.redemptionLocationCount > deal.preferredLocationIndex ? preferredOption.redemptionLocations[deal.preferredLocationIndex].lng : deal.division.lng
            }
          };
        } else {
          return deal.locations.map((location, locationIndex) => {
            return {
              index: locationIndex,
              type: 'clo',
              id: deal.id,
              _raw: deal,
              title: deal.title,
              short_title: deal.title,
              locations: deal.locations,
              cashback_percentage: deal.cashBackPercentage / 100,
              image_url: deal['image-url'],
              merchant: {
                name: deal['advertiser-name'],
                latitude: location.latitude,
                longitude: location.longitude
              }
            };
          });
        }
      }).flat();
      offers.forEach(offer => {
        if (!this.getRebateDetails(offer.id)) {
          this.cachedOffers.push(offer);
        }
      })
      return offers;
    } else {
      return results.deals.map(dealWrapper => dealWrapper.deal);
    }
  }

  getRebateDetails(id: string) {
    return this.cachedOffers.find(offer => id === offer.id);
  }

  getRebates() {
    return this.restangular.one('v3').one('rebates').get().toPromise().then(result => {
      return this.reformatResults(result);
    });
  }

  getRebatesByCategoryAndLocation(categorySlug: string, latitude: number, longitude: number, radius: number) {
    if (!categorySlug) {
      return this.getRebatesByLocation(latitude, longitude, radius);
    } else {
      return this.restangular.one('v3').one('rebates').one('categoryandlocation', categorySlug).one(latitude.toString()).one(longitude.toString()).one(radius.toString()).get().toPromise().then(result => {
        return this.reformatResults(result);
      });
    }
  }

  getRebatesByCategory(categorySlug: string) {
    return this.restangular.one('v3').one('rebates').one('category', categorySlug).get().toPromise().then(result => {
      return this.reformatResults(result);
    });
  }

  getRebatesByLocation(latitude: number, longitude: number, radius: number) {
    return this.restangular.one('v3').one('rebates').one('location').one(latitude.toString()).one(longitude.toString()).one(radius.toString()).get().toPromise().then(result => {
      return this.reformatResults(result);
    });
  }

}
